"use client";

import { Home } from "lucide-react";
import { useTranslations } from "next-intl";
import { useEffect } from "react";

import { RandomFoodIcon } from "@/components/shared/RandomFoodIcon";
import { Button } from "@/components/ui/button";
import { Link } from "@/i18n/navigation";

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function Error({ error, reset }: ErrorProps) {
  const t = useTranslations("error");

  useEffect(() => {
    console.error("Error:", error);
  }, [error]);

  return (
    <div className="min-h-dvh bg-background flex items-center justify-center px-3">
      <div className="flex flex-col items-center justify-center gap-6 max-w-md text-center">
        <RandomFoodIcon categories={["produce"]} />

        <div className="space-y-2">
          <h2 className="text-xl sm:text-2xl font-semibold text-foreground">{t("title")}</h2>
        </div>

        <p className="text-base sm:text-lg text-text-secondary max-w-sm">{t("description")}</p>

        <div className="flex flex-col sm:flex-row gap-3 mt-2">
          <Button onClick={reset} variant="outline" size="lg" className="gap-2">
            {t("tryAgain")}
          </Button>
          <Link href="/">
            <Button size="lg" className="gap-2">
              <Home className="size-5" />
              {t("backToHome")}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
